import { Box, Typography } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { BlockClicks } from "lib/@components/block-clicks"
import { StyledToolTip } from "lib/@components/styled-tool-tip"
import Iconify from "minimals-template/components/Iconify"

export function IsLockedToolTip() {
    const { lockData } = useBoundContext()

    let color = "text.secondary"
    let summary = `This schedule is currently assigned to Work Package: ${lockData.projectName}`

    if (lockData.inCurrentProject) {
        color = "primary.main"
        summary = `This schedule is added to the current Work Package: ${lockData.projectName}`
    }

    return (
        <StyledToolTip
            arrow
            placement="right"
            enterNextDelay={300}
            title={
                <Typography sx={{ lineHeight: 1.1 }} variant="body2">
                    {summary}
                </Typography>
            }
            enterDelay={300}
        >
            <BlockClicks>
                <Box sx={{ ml: 1, color: color, lineHeight: 0, fontSize: 18 }} data-cy="is-locked-tool-tip">
                    <Iconify icon="si:warning-fill" />
                </Box>
            </BlockClicks>
        </StyledToolTip>
    )
}
